import {Component, OnInit, ViewChild} from '@angular/core';
import {CrudConfig} from '@ngx-ivengi/crud';
import {CustomerDatatableComponent} from './customer-datatable.component';

@Component({
  selector: 'app-customer-overview',
  templateUrl: './customer-overview.component.html'
})
export class CustomerOverviewComponent implements OnInit {
  public initialized: boolean = false;
  private nameFilterId = this.crudConfig.getFilterId();
  private addressFilterId = this.crudConfig.getFilterId();
  private zipFilterId = this.crudConfig.getFilterId();
  private cityFilterId = this.crudConfig.getFilterId();
  private countryFilterId = this.crudConfig.getFilterId();

  @ViewChild(CustomerDatatableComponent)
  private dataTable: CustomerDatatableComponent;

  constructor(
    private crudConfig: CrudConfig
  ) {}

  public ngOnInit(): void {
    this.initialized = true;
  }

  public filter(event) {
    this.dataTable.requestParams
      .addFilterParam({
        id: this.nameFilterId,
        key: 'name',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true'
      })
      .addFilterParam({
        id: this.addressFilterId,
        key: 'address.address',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.zipFilterId,
        key: 'address.zip',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.cityFilterId,
        key: 'address.city',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.countryFilterId,
        key: 'address.country',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      });

    this.dataTable.filter(event);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer-overview.component.ts